// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-title {
  margin-left: 15px;
  padding: 0; }
  .page-title .col-6 {
    padding: 0 !important; }
  .page-title .search-wrapper input {
    height: 37px;
    margin-left: 10px; }
  .page-title .select-first {
    width: 250px;
    height: 37px;
    border-radius: 5px;
    margin-top: -100px; }
  .page-title .right {
    margin-bottom: 10px; }
  .page-title .jce {
    display: flex;
    justify-content: flex-end; }
  .page-title input.search {
    width: 240px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border-right: none;
    padding-left: 10.6px;
    outline: none;
    font-family: "Roboto"; }
  .page-title .search-btn {
    margin-left: -0.5px;
    height: 37px;
    width: 40px;
    border-top-right-radius: 7px;
    border-bottom-right-radius: 7px;
    outline: none;
    border: none;
    background: #1c72b2;
    color: #ffffff;
    padding-left: 5.5px; }
  .page-title .search-wrapper {
    border-radius: 25px;
    border: 1px solid #b6b6b6;
    background-color: #ffffff;
    padding: 0px 5px; }
    .page-title .search-wrapper input {
      border: none;
      border-radius: 25px;
      margin-left: 0px;
      padding: 0px 10px; }
      .page-title .search-wrapper input:focus, .page-title .search-wrapper input:focus-within {
        outline: none !important;
        border: none !important; }
    .page-title .search-wrapper:focus-within {
      border: 1px solid #f58a1f; }
    .page-title .search-wrapper svg {
      color: #8a8a8a; }
`, "",{"version":3,"sources":["webpack://./src/components/pagetitle/pagetitle.scss"],"names":[],"mappings":"AAEA;EAGE,iBAAiB;EACjB,UAAU,EAAA;EAJZ;IAMI,qBAAqB,EAAA;EANzB;IAcI,YAAY;IACZ,iBAAiB,EAAA;EAfrB;IAoBI,YAAY;IACZ,YAAY;IAEZ,kBAAkB;IAClB,kBAAkB,EAAA;EAxBtB;IAiCI,mBAAmB,EAAA;EAjCvB;IAoCI,aAAa;IACb,yBAAyB,EAAA;EArC7B;IAwCI,YAAY;IACZ,2BAA2B;IAC3B,8BAA8B;IAC9B,kBAAkB;IAClB,oBAAoB;IAEpB,aAAa;IACb,qBAAqB,EAAA;EA/CzB;IAkDI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,+BAA+B;IAC/B,aAAa;IAEb,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,mBAAmB,EAAA;EA5DvB;IAiEI,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB,EAAA;IApEpB;MAsEM,YAAY;MACZ,mBAAmB;MACnB,gBAAgB;MAChB,iBAAiB,EAAA;MAzEvB;QA6EQ,wBAAwB;QACxB,uBAAuB,EAAA;IA9E/B;MAkFM,yBAAyB,EAAA;IAlF/B;MAqFM,cAAc,EAAA","sourcesContent":["// @import '../../../shared/styles/scss/variables.scss';\n\n.page-title {\n  // height: 30px;\n  // border: 1px solid;\n  margin-left: 15px;\n  padding: 0;\n  .col-6 {\n    padding: 0 !important;\n  }\n  // .widgets-group {\n  //   @media screen and (max-width: $xs) {\n  //     margin-top: -20px;\n  //   }\n  // }\n  .search-wrapper input {\n    height: 37px;\n    margin-left: 10px;\n  }\n\n  .select-first {\n    // margin-left: -150px;\n    width: 250px;\n    height: 37px;\n    // border: 1px solid $dark-gray-2;\n    border-radius: 5px;\n    margin-top: -100px;\n  }\n\n  // .title {\n  //   // font-weight: bold;\n  //   @media screen and (max-width: $lg) {\n  //   }\n  // }\n  .right {\n    margin-bottom: 10px;\n  }\n  .jce {\n    display: flex;\n    justify-content: flex-end;\n  }\n  input.search {\n    width: 240px;\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n    border-right: none;\n    padding-left: 10.6px;\n    // border: 1px solid $dark-gray-2;\n    outline: none;\n    font-family: \"Roboto\";\n  }\n  .search-btn {\n    margin-left: -0.5px;\n    height: 37px;\n    width: 40px;\n    border-top-right-radius: 7px;\n    border-bottom-right-radius: 7px;\n    outline: none;\n    // border: 1.25px solid #1c72b2;\n    border: none;\n    background: #1c72b2;\n    color: #ffffff;\n    padding-left: 5.5px;\n  }\n\n  // New UI Search Input\n  .search-wrapper {\n    border-radius: 25px;\n    border: 1px solid #b6b6b6;\n    background-color: #ffffff;\n    padding: 0px 5px;\n    input {\n      border: none;\n      border-radius: 25px;\n      margin-left: 0px;\n      padding: 0px 10px;\n      // background-color: #f4f5f7;\n      &:focus,\n      &:focus-within {\n        outline: none !important;\n        border: none !important;\n      }\n    }\n    &:focus-within {\n      border: 1px solid #f58a1f;\n    }\n    svg {\n      color: #8a8a8a;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
